import React, { useState } from "react";
import { Container, Row, Col, Button, Card, Spinner } from "react-bootstrap";
import Header from "./components/Header";
import LanguageSelect from "./components/LanguageSelect";
import Editor from "./components/Editor";
import { CODE_SNIPPETS } from "./constants/boilerplate";
import { executeCode } from "./services/api";
import "./styles/custom.css";

function App() {
  const [language, setLanguage] = useState("javascript");
  const [code, setCode] = useState(CODE_SNIPPETS["javascript"]);
  const [output, setOutput] = useState("// Output will appear here");
  const [isLoading, setIsLoading] = useState(false);

  // Handle language change
  const onLanguageChange = (selectedName) => {
    setLanguage(selectedName);
    // Update code to boilerplate if needed, or keep previous state? 
    // Usually editors switch to boilerplate of new language or keep user code if relevant?
    // User requirement: "Changes Monaco editor language dynamically" + "Default boilerplate code per language"
    // So usually resetting to boilerplate is safer for a simple editor logic unless we cache.
    setCode(CODE_SNIPPETS[selectedName] || "");
    setOutput("// Output will appear here");
  };

  const handleRunCode = async () => {
    setIsLoading(true);
    setOutput("Running code...");
    try {
      const result = await executeCode(language, code);
      // Judge0 run result structure
      // If wait=true, we get { stdout, stderr, compile_output, message, status }
      // Status ID 3 is Accepted.
      const { stdout, stderr, compile_output, message } = result;

      if (message) {
        setOutput(`Error: ${message}`);
      } else {
        // Prefer stdout, then stderr, then compile_output (for compilation errors)
        const finalOutput = stdout || stderr || compile_output || "Execution completed with no output.";
        setOutput(finalOutput);
      }

    } catch (error) {
      setOutput(`Error: ${error.message || "Failed to execute code"}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App d-flex flex-column min-vh-100">
      <Header />

      <Container fluid className="px-4 app-main d-flex flex-column">
        <Row className="mb-3 align-items-center flex-shrink-0">
          <Col xs={12} md={6} className="d-flex align-items-center">
            <LanguageSelect
              selectedLanguage={language}
              onLanguageChange={onLanguageChange}
            />
            <div className="ms-auto">
              <Button
                variant="success"
                onClick={handleRunCode}
                className="px-4"
                disabled={isLoading}
              >
                {isLoading ? <Spinner animation="border" size="sm" /> : "Run Code"}
              </Button>
            </div>
          </Col>
          <Col xs={12} md={6}>
            {/* Output controls if any */}
          </Col>
        </Row>

        <Row className="flex-grow-1 overflow-hidden pb-3">
          <Col xs={12} md={6} className="h-100">
            <Editor
              language={language}
              code={code}
              theme="vs-dark"
              onChange={setCode}
            />
          </Col>
          <Col xs={12} md={6} className="mt-3 mt-md-0 h-100">
            <Card className="h-100 shadow-sm" style={{ minHeight: '300px' }}>
              <Card.Header className="bg-light fw-bold">Output</Card.Header>
              <Card.Body className="font-monospace bg-light" style={{ overflow: 'auto' }}>
                <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{output}</pre>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>


    </div>
  );
}

export default App;
